export const environment = {
  production: false
};

import 'zone.js/dist/zone-error';  // Included with Angular CLI.

export const LOG_OUTPUT = true;
export const ERROR_OUTPUT = true;

// export const API_ENDPOINT = 'https://sympto.cmtest.rocks/sympto/api/';
// export const ENDPOINT = 'https://sympto.cmtest.rocks/sympto/';
export const API_ENDPOINT = 'https://sympto.org/api/';
export const ENDPOINT = 'https://sympto.org/';
export const API_TOKEN_NAME = 'X-Auth-Token';
export const API_PLATFORM = 'X-Is-App';
export const API_PLATFORM_SYSTEM = 'X-Platform-System';
export const SESSION_ID_NAME = 'X-SessionId';
export const API_HTTP_REQUEST_TIMEOUT = 50000;

export const STORAGE_SESSIONID_NAME = 'sympto-sessionid';
export const STORAGE_TOKEN_NAME = 'sympto-token';
export const STORAGE_USER_NAME = 'sympto-user';
export const STORAGE_CYCLE_LIST = 'cycle_list';
export const STORAGE_CYCLE_TITLE = 'cycle_name';
export const STORAGE_CYCLE_PDFLINK = 'cycle_pdflink';
export const STORAGE_CYCLE_LIST_TITLE = 'cycle_list_title';
export const STORAGE_IFRAME_PARAMS = 'sympto_iframeparams';

export const APP_NAVIGATION_CALL = 'navigate-to';
